<template>
    <div>
        <div class="hint block" v-if="limitFlag">
            <div class="title">温馨提示</div>
            <p>资产快捷选择最多支持500个，请按需勾选条件</p>
        </div>
        <div class="form-info">
            <div class="content-caption dashed">
                <span>管理方式</span>
            </div>
            <div class="form-row" v-if="showSingle">
                <div class="form-value">
                    <el-checkbox v-model="resultFilter.includeSingle" @change="includeSingleChange">单品式管理</el-checkbox>
                    <span v-if="showSingleSpecial || showSingleComn">
                        <span>（</span>
                        <el-checkbox v-if="showSingleSpecial" @change="includeSingleSpecialChange" v-model="resultFilter.includeSingleSpecial" :disabled="resultFilter.includeSingle == false">
                            <span>特种设备</span>
                        </el-checkbox>
                        <el-checkbox v-if="showSingleComn" @change="includeSinleComnChange" v-model="resultFilter.includeSingleComn" :disabled="resultFilter.includeSingle == false">
                            <span>非特种设备</span>
                        </el-checkbox>
                        <span>）</span>
                    </span>
                </div>
            </div>
            <div class="form-row" v-if="showBatch && showBatchLow">
                <div class="form-value">
                    <el-checkbox @change="includeBatchLowChange" v-model="resultFilter.includeBatchLow">
                        <span>耗材管理</span>
                    </el-checkbox>
                </div>
            </div>
            <div class="form-row" v-if="showBatch && showBatchComn">
                <div class="form-value">
                    <el-checkbox @change="includeBatchComnChange" v-model="resultFilter.includeBatchComn">
                        <span>批量管理</span>
                    </el-checkbox>
                </div>
            </div>
            <div v-if="showWarehouse">
                <div class="content-caption dashed">
                    <span>所属仓库</span>
                    <el-checkbox class="ml5" v-model="resultFilter.warehouseIdAll" @change="warehouseIdAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.warehouseIds" @change="warehouseIdsChange">
                        <el-checkbox class="mt10" :label="item.id" v-for="item in dbOptions.warehouseList">
                            <span>{{item.name}}</span>
                            <span class="font-gray2">
                                <span>(</span>
                                <span>{{showSingle ? '单' + item.singleCount + '个' : ''}}</span>
                                <span>{{showBatch ? '批' + item.batchCount + '个' : ''}}</span>
                                <span>)</span>
                            </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div v-if="showGroup && dbOptions.groupList != null && dbOptions.groupList.length > 0">
                <div class="content-caption dashed">
                    <span>维保分组</span>
                    <el-checkbox class="ml5" v-model="resultFilter.groupAll" @change="devcGroupAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.devcGroupIds" @change="devcGroupsChange">
                        <el-checkbox class="mt10" :label="item.id" v-for="item in dbOptions.groupList">
                            <span>{{item.name}}</span>
                            <span class="font-gray2">
                                <span>(</span>
                                <span>{{showSingle ? '单' + item.singleCount + '个' : ''}}</span>
                                <span>{{showBatch ? '批' + item.batchCount + '个' : ''}}</span>
                                <span>)</span>
                            </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div v-if="showCat && dbOptions.catList != null && dbOptions.catList.length > 0">
                <div class="content-caption dashed">
                    <span>分类</span>
                    <el-checkbox class="ml5" v-model="resultFilter.catIdAll" @change="catIdsAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.catIds" @change="catIdsChange">
                        <el-checkbox class="mt10" :label="item.id" v-for="item in dbOptions.catList">
                            <span>{{item.name}}</span>
                            <span class="font-gray2">
                                <span>(</span>
                                <span>{{showSingle ? '单' + item.singleCount + '个' : ''}}</span>
                                <span>{{showBatch ? '批' + item.batchCount + '个' : ''}}</span>
                                <span>)</span>
                            </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

            <div v-if="showDepart && dbOptions.departList != null && dbOptions.departList.length > 0">
                <div class="content-caption dashed">
                    <span>责任部门</span>
                    <el-checkbox class="ml5" v-model="resultFilter.departIdAll" @change="departIdsAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.departIds" @change="departIdsChange">
                        <el-checkbox class="mt10" :label="item.id" v-for="item in dbOptions.departList">
                            <span>{{item.name}}</span>
                            <span class="font-gray2">
                                <span>(</span>
                                <span>{{showSingle ? '单' + item.singleCount + '个' : ''}}</span>
                                <span>{{showBatch ? '批' + item.batchCount + '个' : ''}}</span>
                                <span>)</span>
                            </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div v-if="showKind && dbOptions.kindList != null && dbOptions.kindList.length > 0">
                <div class="content-caption dashed">
                    <span>财务类别</span>
                    <el-checkbox class="ml5" v-model="resultFilter.kindIdAll" @change="kindIdsAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.kindIds" @change="kindIdsChange">
                        <el-checkbox class="mt10" :label="item.id" v-for="item in dbOptions.kindList">
                            <span>{{item.name}}</span>
                            <span class="font-gray2">
                                <span>(</span>
                                <span>{{showSingle ? '单' + item.singleCount + '个' : ''}}</span>
                                <span>{{showBatch ? '批' + item.batchCount + '个' : ''}}</span>
                                <span>)</span>
                            </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div v-if="showAcctEnterWay && dbOptions.acctEnterWayList != null && dbOptions.acctEnterWayList.length > 0">
                <div class="content-caption dashed">
                    <span>入账方式</span>
                    <el-checkbox class="ml5" v-model="resultFilter.acctEnterWayAll" @change="acctEnterWaysAllChange">
                        <span>全选</span>
                    </el-checkbox>
                </div>
                <div>
                    <el-checkbox-group v-model="resultFilter.acctEnterWays" @change="acctEnterWaysChange">
                        <el-checkbox class="mt10" :label="item.value" v-for="item in dbOptions.acctEnterWayList">
                            <span>{{item.text}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-asset-advanced-select',
        desc: '资产快捷选择',
        props: {
            // 机构id，必传
            retailerShopId: {
                type: Number,
                value: null
            },
            onlyDepart: {
                type: Boolean,
                value: false
            },
            checkBatch: { // 是否选中批量
                type: Boolean,
                value: true
            },
            // 仓库id，选填
            warehouseId: {
                type: Number,
                value: null
            },
            // 是否显示单品（默认显示）
            showSingle: {
                type: Boolean,
                value: true
            },
            // 非特种设备
            showSingleComn: {
                type: Boolean,
                value: false
            },
            // 特种设备
            showSingleSpecial: {
                type: Boolean,
                value: false
            },
            // 是否显示批量（默认显示）
            showBatch: {
                type: Boolean,
                value: true
            },
            // 是否显示批量-通用（默认不显示）
            showBatchComn: {
                type: Boolean,
                value: false
            },
            // 是否显示批量-耗材（默认不显示）
            showBatchLow: {
                type: Boolean,
                value: false
            },
            // 是否显示仓库(如果传入仓库id则不显示)
            showWarehouse: {
                type: Boolean,
                value: false
            },
            // 是否显示责任部门
            showDepart: {
                type: Boolean,
                value: false
            },
            // 是否显示维保分组
            showGroup: {
                type: Boolean,
                value: false
            },
            // 是否显示分类
            showCat: {
                type: Boolean,
                value: false
            },
            // 是否显示财务类别
            showKind: {
                type: Boolean,
                value: false
            },
            // 是否显示入账方式
            showAcctEnterWay: {
                type: Boolean,
                value: false
            },
            singleFilter: {
                type: Object,
                value: null
            },
            batchFilter: {
                type: Object,
                value: null
            },
            // 回显参数
            dbResultFilter: {
                type: Object,
                value: null
            },
            // 是否控制条数500
            limitFlag: {
                type: Boolean,
                value: true
            }
        },
        data: function () {
            return {
                resultFilter: {
                    includeSingle: true,
                    includeSingleSpecial: false,
                    includeSingleComn: false,
                    includeBatch: true,
                    includeBatchLow: false,
                    includeBatchComn: false,
                    lowCostFlag: null,
                    warehouseIds: [],
                    warehouseIdAll: false,
                    departIds: [],
                    departIdAll: false,
                    catIds: [],
                    catIdAll: false,
                    kindIds: [],
                    kindIdAll: false,
                    acctEnterWays: [],
                    acctEnterWayAll: false,
                    devcGroupIds: [],
                    groupAll: false,
                },
                dbOptions: {}
            }
        },
        created: function () {
            this.initData();
        },
        methods: {
            initData(){
                let retailerShopId = this.retailerShopId;
                if(Utils.isNoB(retailerShopId)) {
                    MsgBox.warning('传参错误');
                    return;
                }
                if(Utils.isFalse(this.showSingle) && Utils.isFalse(this.showBatch)) {
                    MsgBox.warning('传参错误');
                    return;
                }
                let resultFilter = this.resultFilter;
                resultFilter.retailerShopId = retailerShopId;
                if(this.showSingle) {
                    resultFilter.includeSingle = true;
                    resultFilter = this.initSpecialFlag(resultFilter);
                    resultFilter = this.handleSpecial(resultFilter);
                } else {
                    resultFilter.includeSingle = false;
                }
                if(!this.checkBatch) {
                    resultFilter.includeBatch = false;
                } else if(this.showBatch) {
                    resultFilter.includeBatch = true;
                    resultFilter = this.initLowCostFlag(resultFilter);
                    resultFilter = this.handleLow(resultFilter);
                } else {
                    resultFilter.includeBatch = false;
                }
                let warehouseId = this.warehouseId;
                if(warehouseId != null) {
                    resultFilter.warehouseId = warehouseId;
                    if(this.showWarehouse) {
                        MsgBox.warning('传参错误');
                        return;
                    }
                }
                //
                if(!Utils.isNoB(this.dbResultFilter)) {
                    resultFilter = Utils.merge({}, this.dbResultFilter);
                }
                resultFilter = this.handleAll(resultFilter);
                resultFilter.singleFilter = this.singleFilter;
                resultFilter.batchFilter = this.batchFilter;
                this.resultFilter = resultFilter;
                if(this.showWarehouse || this.showDepart || this.showCat || this.showKind) {
                    let postData = {};
                    postData.retailerShopId = retailerShopId;
                    postData.onlyDepart = this.onlyDepart;
                    if(warehouseId != null) {
                        postData.warehouseId = warehouseId;
                    }
                    postData.showSingle = this.showSingle;//
                    postData.showBatch = this.showBatch;
                    postData.showBatchLow = this.showBatchLow;
                    postData.showGroup = this.showGroup;
                    postData.lowCostFlag = resultFilter.lowCostFlag;
                    postData.showWarehouse = this.showWarehouse;
                    postData.showDepart = this.showDepart;
                    postData.showCat = this.showCat;
                    postData.showKind = this.showKind;
                    postData.singleFilter = this.singleFilter;
                    postData.batchFilter = this.batchFilter;
                    this.getAssetAdvancedOptions(postData);
                } else if(this.showAcctEnterWay) {
                    this.dbOptions = this.handleAcctEnterWayList({});
                }
            },
            handleAcctEnterWayList(dbOptions) {
                let acctEnterWayList = getEnumList('acctEnterWay');
                dbOptions.acctEnterWayList = acctEnterWayList;
                return dbOptions;
            },
            initLowCostFlag(resultFilter){
                if(this.showBatchComn || this.showBatchLow) {
                    if(this.showBatchComn) {
                        resultFilter.lowCostFlag = false;
                    }
                    if(this.showBatchLow) {
                        resultFilter.lowCostFlag = true;
                    }
                    if(this.showBatchComn && this.showBatchLow) {
                        resultFilter.lowCostFlag = null;
                    }
                }
                return resultFilter;
            },
            initSpecialFlag(resultFilter){
                if(this.showSingleComn || this.showSingleSpecial) {
                    if(this.showSingleComn) {
                        resultFilter.specialFlag = false;
                    }
                    if(this.showSingleSpecial) {
                        resultFilter.specialFlag = true;
                    }
                    if(this.showSingleComn && this.showSingleSpecial) {
                        resultFilter.specialFlag = null;
                    }
                }
                return resultFilter;
            },
            handleLow(resultFilter){
                if(resultFilter.includeBatch && (resultFilter.lowCostFlag == null || resultFilter.lowCostFlag == true)) {
                    resultFilter.includeBatchLow = true;
                } else {
                    resultFilter.includeBatchLow = false;
                }
                if(resultFilter.includeBatch && (resultFilter.lowCostFlag == null || resultFilter.lowCostFlag == false)) {
                    resultFilter.includeBatchComn = true;
                } else {
                    resultFilter.includeBatchComn = false;
                }
                return resultFilter;
            },
            handleSpecial(resultFilter){
                if(resultFilter.includeSingle && (resultFilter.specialFlag == null || resultFilter.specialFlag == true)) {
                    resultFilter.includeSingleSpecial = true;
                } else {
                    resultFilter.includeSingleSpecial = false;
                }
                if(resultFilter.includeSingle && (resultFilter.specialFlag == null || resultFilter.specialFlag == false)) {
                    resultFilter.includeSingleComn = true;
                } else {
                    resultFilter.includeSingleComn = false;
                }
                return resultFilter;
            },
            getAssetAdvancedOptions(postData){
                let self = this;
                let theLoad = MsgBox.loading();
                shopDevcApi.getAssetAdvancedOptions(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let dbOptions = result.data;
                        dbOptions = self.handleAcctEnterWayList(dbOptions);
                        self.dbOptions = dbOptions;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            includeSingleChange(){
                let resultFilter = this.resultFilter;
                if(this.resultFilter.includeSingle) {
                    resultFilter = this.initSpecialFlag(resultFilter);
                } else if(this.resultFilter.includeBatch == false) {
                    Toast.show('至少选择一种管理方式');
                    this.resultFilter.includeSingle = true;
                }
                resultFilter = this.handleSpecial(resultFilter);
                this.resultFilter = resultFilter;
            },
            includeBatchChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.includeBatch) {
                    resultFilter = this.initLowCostFlag(resultFilter);
                } else if(this.resultFilter.includeSingle == false) {
                    Toast.show('至少选择一种管理方式');
                    resultFilter.includeBatch = true;
                }
                resultFilter = this.handleLow(resultFilter);
                this.resultFilter = resultFilter;
            },
            includeBatchLowChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.includeBatchLow) {
                    resultFilter.lowCostFlag = null;
                    resultFilter.includeBatch = true;
                } else {
                    if(resultFilter.lowCostFlag == true) {
                        if(resultFilter.includeSingle == false) {
                            Toast.show('至少选择一种管理方式');
                        } else {
                            resultFilter = this.initLowCostFlag(resultFilter);
                            resultFilter.includeBatch = false;
                        }
                    } else {
                        resultFilter.lowCostFlag = false;
                    }
                }
                resultFilter = this.handleLow(resultFilter);
                this.resultFilter = resultFilter;
            },
            includeBatchComnChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.includeBatchComn) {
                    // resultFilter.lowCostFlag = null;
                    resultFilter.includeBatch = true;
                } else {
                    if(resultFilter.lowCostFlag == false) {
                        if(resultFilter.includeSingle == false) {
                            Toast.show('至少选择一种管理方式');
                        } else {
                            resultFilter = this.initLowCostFlag(resultFilter);
                            resultFilter.includeBatch = false;
                        }
                    } else {
                        resultFilter.lowCostFlag = true;
                    }
                }
                resultFilter = this.handleLow(resultFilter);
                this.resultFilter = resultFilter;
            },
            includeSingleSpecialChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.includeSingleSpecial) {
                    resultFilter.specialFlag = null;
                    resultFilter.includeSingle = true;
                } else {
                    if(resultFilter.specialFlag == true) {
                        if(resultFilter.includeBatch == false) {
                            Toast.show('至少选择一种管理方式');
                        } else {
                            resultFilter = this.initSpecialFlag(resultFilter);
                            resultFilter.includeSingle = false;
                        }
                    } else {
                        resultFilter.specialFlag = false;
                    }
                }
                resultFilter = this.handleSpecial(resultFilter);
                this.resultFilter = resultFilter;
            },
            includeSinleComnChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.includeSingleComn) {
                    resultFilter.specialFlag = null;
                    resultFilter.includeSingle = true;
                } else {
                    if(resultFilter.specialFlag == false) {
                        if(resultFilter.includeBatch == false) {
                            Toast.show('至少选择一种管理方式');
                        } else {
                            resultFilter = this.initSpecialFlag(resultFilter);
                            resultFilter.includeSingle = false;
                        }
                    } else {
                        resultFilter.specialFlag = true;
                    }
                }
                resultFilter = this.handleSpecial(resultFilter);
                this.resultFilter = resultFilter;
            },
            handleAll(resultFilter){
                if(!Utils.isNoB(this.dbOptions.warehouseList)) {
                    resultFilter = this.handleWarehouseAll(resultFilter);
                }
                if(!Utils.isNoB(this.dbOptions.departList)) {
                    resultFilter = this.handleDepartAll(resultFilter);
                }
                if(!Utils.isNoB(this.dbOptions.catList)) {
                    resultFilter = this.handleCatAll(resultFilter);
                }
                if(!Utils.isNoB(this.dbOptions.kindList)) {
                    resultFilter = this.handleKindAll(resultFilter);
                }
                if(!Utils.isNoB(this.dbOptions.groupList)) {
                    resultFilter = this.handleGroupAll(resultFilter);
                }
                if(!Utils.isNoB(this.dbOptions.acctEnterWayList)) {
                    resultFilter = this.handleAcctEnterWayAll(resultFilter);
                }
                return resultFilter;
            },
            handleWarehouseAll(resultFilter){
                if(resultFilter.warehouseIds.length == this.dbOptions.warehouseList.length) {
                    resultFilter.warehouseIdAll = true;
                } else {
                    resultFilter.warehouseIdAll = false;
                }
                return resultFilter;
            },
            handleDepartAll(resultFilter){
                if(resultFilter.departIds.length == this.dbOptions.departList.length) {
                    resultFilter.departIdAll = true;
                } else {
                    resultFilter.departIdAll = false;
                }
                return resultFilter;
            },
            handleCatAll(resultFilter){
                if(resultFilter.catIds.length == this.dbOptions.catList.length) {
                    resultFilter.catIdAll = true;
                } else {
                    resultFilter.catIdAll = false;
                }
                return resultFilter;
            },
            handleGroupAll(resultFilter){
                if(resultFilter.devcGroupIds.length == this.dbOptions.groupList.length) {
                    resultFilter.groupAll = true;
                } else {
                    resultFilter.groupAll = false;
                }
                return resultFilter;
            },
            handleKindAll(resultFilter){
                if(resultFilter.kindIds.length == this.dbOptions.kindList.length) {
                    resultFilter.kindIdAll = true;
                } else {
                    resultFilter.kindIdAll = false;
                }
                return resultFilter;
            },
            handleAcctEnterWayAll(resultFilter){
                if(resultFilter.acctEnterWays.length == this.dbOptions.acctEnterWayList.length) {
                    resultFilter.acctEnterWayAll = true;
                } else {
                    resultFilter.acctEnterWayAll = false;
                }
                return resultFilter;
            },
            warehouseIdAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.warehouseIdAll) {
                    resultFilter.warehouseIds = this.dbOptions.warehouseList.pluck('id');
                } else {
                    resultFilter.warehouseIds = [];
                }
                this.resultFilter = resultFilter;
            },
            warehouseIdsChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleWarehouseAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            departIdsAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.departIdAll) {
                    resultFilter.departIds = this.dbOptions.departList.pluck('id');
                } else {
                    resultFilter.departIds = [];
                }
                this.resultFilter = resultFilter;
            },
            departIdsChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleDepartAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            catIdsAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.catIdAll) {
                    resultFilter.catIds = this.dbOptions.catList.pluck('id');
                } else {
                    resultFilter.catIds = [];
                }
                this.resultFilter = resultFilter;
            },
            devcGroupAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.groupAll) {
                    resultFilter.devcGroupIds = this.dbOptions.groupList.pluck('id');
                } else {
                    resultFilter.devcGroupIds = [];
                }
                this.resultFilter = resultFilter;
            },
            catIdsChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleCatAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            devcGroupsChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleGroupAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            kindIdsAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.kindIdAll) {
                    resultFilter.kindIds = this.dbOptions.kindList.pluck('id');
                } else {
                    resultFilter.kindIds = [];
                }
                this.resultFilter = resultFilter;
            },
            kindIdsChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleKindAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            acctEnterWaysAllChange(){
                let resultFilter = this.resultFilter;
                if(resultFilter.acctEnterWayAll) {
                    resultFilter.acctEnterWays = this.dbOptions.acctEnterWayList.pluck('value');
                } else {
                    resultFilter.acctEnterWays = [];
                }
                this.resultFilter = resultFilter;
            },
            acctEnterWaysChange(){
                let resultFilter = this.resultFilter;
                resultFilter = this.handleAcctEnterWayAll(resultFilter);
                this.resultFilter = resultFilter;
            },
            getDlgResult(){
                let result = {
                    type: "info"
                };
                result.data = {
                    resultFilter: this.resultFilter,
                    viewData: {
                        showSingle: this.showSingle,
                        showSingleComn: this.showSingleComn,
                        showSingleSpecial: this.showSingleSpecial,
                        showBatch: this.showBatch,
                        showBatchComn: this.showBatchComn,
                        showBatchLow: this.showBatchLow,
                        showWarehouse: this.showWarehouse,
                        showDepart: this.showDepart,
                        showGroup: this.showGroup,
                        showCat: this.showCat,
                        showKind: this.showKind,
                        showAcctEnterWay: this.showAcctEnterWay,
                        dbOptions: this.dbOptions
                    }
                };
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asset/AssetAdvancedSelect.vue